import React from "react";
import { injectIntl } from "react-intl";
import {
  TableWrapper,
  Table,
  THead,
  TBody,
  TR,
  TH,
  TD,
  EditButton,
  EditIcon,
  Tooltip,
  TFoot,
  EditButtonCell,
} from "../styled";

const HorizontalTable = (props) => {
  const {
    columns,
    rows,
    widths,
    builder,
    validationError,
    renderInput,
    toggleLockRow,
    deleteRow,
    sumColumn,
    intl,
    toggleLockCell,
    openSettings,
    enableCellLock,
    disabled,
  } = props;

  return (
    <TableWrapper>
      <Table>
        <THead>
          <TR>
            {columns?.map(({ label, type }, i) => (
              <TH
                key={i}
                minWidth={widths[type] || widths.default}
                checkbox={type === "checkbox"}
              >
                {label}
              </TH>
            ))}
            {builder && <TH width={widths.editButton} />}
            <TH width={widths.editButton}></TH>
          </TR>
        </THead>
        <TBody>
          {rows?.map((row, rowIdx) => (
            <TR key={rowIdx}>
              {columns?.map((column, colIdx) => {
                if (!row.columns[colIdx]) {
                  return null;
                }
                const { critical = {} } = validationError;
                const error = critical[`${rowIdx}:${colIdx}`];
                return (
                  <TD
                    key={colIdx}
                    checkbox={column.type === "checkbox"}
                    error={error}
                  >
                    {renderInput(
                      column.type,
                      row.columns[colIdx].value,
                      rowIdx,
                      colIdx,
                      false,
                      column.disabled || disabled
                    )}
                    {builder && enableCellLock && (
                      <EditButtonCell
                        onClick={() => toggleLockCell(rowIdx, colIdx)}
                      >
                        <EditIcon
                          className={
                            row?.columns[colIdx]?.locked
                              ? "far fa-lock"
                              : "far fa-lock-open"
                          }
                        />
                      </EditButtonCell>
                    )}
                    {error && <Tooltip>{error}</Tooltip>}
                  </TD>
                );
              })}
              {builder && (
                <TD>
                  <EditButton onClick={() => toggleLockRow(rowIdx)}>
                    <EditIcon
                      className={
                        row.locked ? "far fa-lock" : "far fa-lock-open"
                      }
                    />
                  </EditButton>
                  <EditButton onClick={() => openSettings(rowIdx)}>
                    <EditIcon className="fa-regular fa-gear" />
                  </EditButton>
                </TD>
              )}
              <TD>
                <EditButton
                  onClick={() => deleteRow(rowIdx)}
                  disabled={!builder && (row.locked || disabled)}
                >
                  <EditIcon className="far fa-times" />
                </EditButton>
              </TD>
            </TR>
          ))}
        </TBody>
        {rows?.length > 0 && columns.some(({ sum }) => sum) && (
          <TFoot>
            <TR>
              {columns?.map(({ sum = false }, i) => (
                <TD key={i}>
                  {sum &&
                    `${intl.formatMessage({
                      id: "InputTable.Sum",
                    })}: ${sumColumn(i)}`}
                </TD>
              ))}
              <TD />
              {builder && <TD />}
            </TR>
          </TFoot>
        )}
      </Table>
    </TableWrapper>
  );
};

export default injectIntl(HorizontalTable);
